import React, {Component} from 'react'
import CBaseComponent from '@/components/CBaseComponent'
import './index.scss'
import {
  refreshMenu,
} from "../../../../redux/common/action";
import {savedata} from "../../../../servers/commonApi";
import {bindActionCreators, compose} from "redux";
import {Redirect, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {Button, message, Modal, Progress, Tooltip, Upload,Tag} from "antd";
import { List, Card } from 'antd';
import CButton from "../../../../components/CButton";
import CInput from "../../../../components/CForm/CInput";
import CRadio from "../../../../components/CForm/CRadio";
import { Descriptions } from 'antd';
import {getFormApi} from "../../../../servers/user";
import {getuploadfileparams, removepic, selectPicDetail} from "../../../../servers/menu";
import { setStorage} from "@/utils";
import upload from '@/assets/images/upload.png'
import Axios from "axios";
import wenhao from '@/assets/images/wenhao.png'
import { getStorage} from "@/utils";
import store from "../../../../redux";

const axios = Axios.create();
@CBaseComponent
class Infomations extends Component{

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeEdit = this.onChangeEdit.bind(this);
    this.beforeUpload = this.beforeUpload.bind(this);
    this.modalCancel = this.modalCancel.bind(this);
    this.removeFile = this.removeFile.bind(this);
    this.beforeUpload1 = this.beforeUpload1.bind(this);
    this.removeFile1 = this.removeFile1.bind(this);
    this.downloads = this.downloads.bind(this)
    this.inputChange = this.inputChange.bind(this)
    this.radioChange = this.radioChange.bind(this)
    this.nextHandler = this.nextHandler.bind(this)
    this.saveInfo = this.saveInfo.bind(this)
    this.handleCancelstatus = this.handleCancelstatus.bind(this)
    this.lookscore = this.lookscore.bind(this)
  }


  state = {
    levelid:'',
    title:'',
    annextypelist:[],
    data:[],
    uploads: {
      action:'#',
      accept: '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,.gif',
      disabled: false,
      name: 'file',
      showUploadList: false,
      defaultFileList: [],//{uid: '', name: '', url: ''}
      fileList: [],
      limit: 20,//限制上传数量 默认无限制
      size: 1024*1024*30,//默认限制大小为2M
    },
    routers:[],
    open:false,
    uid:'',
    picdetail: {},
    year:'',
    previewVisible:false,
    detailstatus:false,
    detaildata:[],
    meseum:false,
    type:'',
    save:false,
    result:{},
    length:0
  }

  // 点击modal打开
  async handlePreview(file){
    const params = {
      fileid: file.fileid
    }
    selectPicDetail(params).then(res=>{
      if (res.statecode === 0 && res.records[0].filepreviewurl !== '' && res.records[0].filepreviewurl !== null) {
        window.open(res.records[0].filepreviewurl, '_blank')
      }
    })
  }

  downloads(file){
    const params = {
      fileid: file.fileid
    }
    let timer = null
    selectPicDetail(params).then(res=>{
      if (res.statecode === 0 && res.records[0].fileurl !== '' && res.records[0].fileurl !== null) {
        clearTimeout(timer)
        window.location.href = res.records[0].fileurl
      } else {
        timer = setTimeout(()=>{
          this.handlePreview(file)
        },1)
      }
    })
  }

  // 上传之前的判断
  async beforeUpload(file,data,parentdata){
    let name = file.name;
    let size = file.size;
    let currentFileType = name.split('.').pop();
    let fileType = data.extnames.split(',');
    if(data.maxlimit < size){
      message.info('文件大小超过最大限制');
      return false;
    }
    if(fileType.includes(`.${currentFileType}`)){
      let params = {}
      params = {
        annual:this.state.year,
        annexcode: data.annexcode,
        dataid:data.dataid,
        fname:name
      }
      await getuploadfileparams(params).then(res=>{
        if(res.statecode === 0) {
          let formdata = new FormData()
          formdata.append('name', file.name)
          formdata.append('key', res.records[0].key)
          formdata.append('policy', res.records[0].policy)
          formdata.append('OSSAccessKeyId', res.records[0].OSSAccessKeyId)
          formdata.append('success_action_status', res.records[0].success_action_status)
          formdata.append('callback', res.records[0].callback)
          formdata.append('signature', res.records[0].signature)
          formdata.append('x:refid', res.records[0]['x:refid'])
          formdata.append('file', file)
          axios.post(
              res.records[0].host,
              formdata,
              {
                headers:
                    { 'Content-Type': 'multipart/form-data' },
                onUploadProgress:(progressEvent)=>{
                  let processStatu = (((progressEvent.loaded / progressEvent.total) * 100) | 0) ;
                  const result = JSON.parse(JSON.stringify(this.state.data))
                  result.forEach(item=>{
                    if (item.annextypelist !== undefined) {
                      item.annextypelist.forEach(item2=>{
                        if(item2.annexcode === data.annexcode){
                          item2.progress = processStatu
                        } else {
                          item.progress = 0
                        }
                      })
                    }
                  })
                  this.setState({
                    data:result
                  })
                }
              }
          )
              .then(res => {
                if (res.status === 200 && res.data.statecode === 0) {
                  message.success('上传成功')
                  const result = JSON.parse(JSON.stringify(this.state.data))
                  result.forEach(item=>{
                    if (item.code === parentdata.code) {
                      item.annextypelist.forEach(item2=>{
                        if(item2.annexcode === data.annexcode){
                          item2.files.push(res.data.records[0])
                          item2.progress = 0
                        }else {
                          item2.progress = 0
                        }
                      })
                    }
                  })
                  this.setState({
                    data:result
                  })
                } else {
                  message.error('上传失败')
                  const result = JSON.parse(JSON.stringify(this.state.data))
                  result.forEach(item=>{
                    if (item.code === parentdata.code) {
                      item.annextypelist.forEach(item2=>{
                        if(item2.annexcode === data.annexcode){
                          item2.progress = 0
                        }
                      })
                    }
                  })
                  this.setState({
                    data:result
                  })
                }
              })
              .catch(error => {
                message.error('上传失败')
                const result = JSON.parse(JSON.stringify(this.state.data))
                result.forEach(item=>{
                  if (item.code === parentdata.code) {
                    item.annextypelist.forEach(item2=>{
                      if(item2.annexcode === data.annexcode){
                        item2.progress = 0
                      }
                    })
                  }
                })
                this.setState({
                  data:result
                })
              })
        } else {
          message.info(res.statemessage);
        }
      })
      return false;
    }else{
      message.info('请上传指定的文件类型');
    }
  }

  confirmModal = (file,parentdata) => {
    const params = {
      fileid:file.fileid
    }
    removepic(params).then(res=>{
      if (res.statecode === 0) {
        message.success('移除成功')
        const result = JSON.parse(JSON.stringify(this.state.data))
        result.forEach(item=>{
          if (item.code === parentdata.code) {
            item.annextypelist.forEach((item2)=>{
              item2.files.forEach((item3,index)=>{
                if (item3.fileid === file.fileid){
                  item2.files.splice(index,1)
                }
              })

            })
          }
        })
        this.setState({
          data:result
        })
      } else {
        message.error(res.statemessage)
      }
    })
  };

  // 移出文件
  removeFile(file,parentdata){
    Modal.confirm({
      content: '确认移除该附件',
      okText: '确认',
      cancelText: '取消',
      onCancel:()=>{
      },
      onOk:()=>{
        this.confirmModal(file,parentdata)
      }
    });
  }

  // 上传之前的判断
  async beforeUpload1(file,data){
    let name = file.name;
    let size = file.size;
    let currentFileType = name.split('.').pop();
    let fileType = data.extnames.split(',');
    if(data.maxlimit < size){
      message.info('文件大小超过最大限制');
      return false;
    }
    if(fileType.includes(`.${currentFileType}`)){
      let params = {}
      params = {
        annual:this.state.year,
        annexcode: data.annexcode,
        dataid:data.dataid,
        fname:name
      }
      await getuploadfileparams(params).then(res=>{
        if(res.statecode === 0) {
          let formdata = new FormData()
          formdata.append('name', file.name)
          formdata.append('key', res.records[0].key)
          formdata.append('policy', res.records[0].policy)
          formdata.append('OSSAccessKeyId', res.records[0].OSSAccessKeyId)
          formdata.append('success_action_status', res.records[0].success_action_status)
          formdata.append('callback', res.records[0].callback)
          formdata.append('signature', res.records[0].signature)
          formdata.append('x:refid', res.records[0]['x:refid'])
          formdata.append('file', file)
          axios.post(
              res.records[0].host,
              formdata,
              {
                headers:
                    { 'Content-Type': 'multipart/form-data' },
                onUploadProgress:(progressEvent)=>{
                  let processStatu = (((progressEvent.loaded / progressEvent.total) * 100) | 0) ;
                  const result = JSON.parse(JSON.stringify(this.state.annextypelist))
                  result.forEach(item=>{
                      if(item.annexcode === data.annexcode){
                        item.progress = processStatu
                      } else {
                        item.progress = 0
                      }
                  })
                  this.setState({
                    annextypelist:result
                  })
                }
              }
          )
              .then(res => {
                if (res.status === 200 && res.data.statecode === 0) {
                  message.success('上传成功')
                  const result = JSON.parse(JSON.stringify(this.state.annextypelist))
                  result.forEach(item=>{
                    if (item.annexcode === data.annexcode) {
                      item.files.push(res.data.records[0])
                      item.progress = 0
                    } else {
                      item.progress = 0
                    }
                  })
                  this.setState({
                    annextypelist:result
                  })
                  this.onSelect()
                } else {
                  message.error('上传失败')
                  const result = JSON.parse(JSON.stringify(this.state.annextypelist))
                  result.forEach(item=>{
                    if (item.annexcode === data.annexcode) {
                      item.progress = 0
                    }
                  })
                  this.setState({
                    annextypelist:result
                  })
                }
              })
              .catch(error => {
                message.error('上传失败')
                const result = JSON.parse(JSON.stringify(this.state.annextypelist))
                result.forEach(item=>{
                  if (item.annexcode === data.annexcode) {
                    item.progress = 0
                  }
                })
                this.setState({
                  annextypelist:result
                })
              })
        } else {
          message.info(res.statemessage);
        }
      })
      return false;
    }else{
      message.info('请上传指定的文件类型');
    }
  }

  confirmModal1 = (file,parentdata) => {
    const params = {
      fileid:file.fileid
    }
    removepic(params).then(res=>{
      if (res.statecode === 0) {
        message.success('移除成功')
        const result = JSON.parse(JSON.stringify(this.state.annextypelist))
        result.forEach(item=>{
          if (item.code === parentdata.code) {
            item.files.forEach((item3,index)=>{
              if (item3.fileid === file.fileid){
                item.files.splice(index,1)
              }
            })
          }
        })
        this.setState({
          annextypelist:result
        })
        this.onSelect()
      } else {
        message.error(res.statemessage)
      }
    })
  };

  // 移出文件
  removeFile1(file,parentdata){
    Modal.confirm({
      content: '确认移除该附件',
      okText: '确认',
      cancelText: '取消',
      onCancel:()=>{
      },
      onOk:()=>{
        this.confirmModal1(file,parentdata)
      }
    });
  }


  // modal取消
  modalCancel(){
    this.setState({
      previewVisible: false
    })
  }

  handleCancelstatus(){
    this.setState({
      detailstatus: false
    })
  }

  onChangeEdit(data){
    const result = this.state.data
    const d = result[0].data
    d.forEach(item=>{
      if (item.id === data.id){
        item.ifEdit = !item.ifEdit
        if (data.hasupload!== '') {
          d.forEach(item1=>{
            if (item1.id === data.hasupload){
              item1.ifEdit = !item1.ifEdit
            }
          })
        }
      }
    })
    this.setState({
      data:result
    })
  }

  onSelect(){
    const params = {
      annual:this.state.year,
      indid:this.state.indid,
      museumid:this.state.meseum?this.state.museumid:''
    }
    getFormApi(params).then(res=>{
      if (res.statecode === 0) {
        let length = 0
        const result = JSON.parse(JSON.stringify(res.records[0].datalist))
        result.forEach(item=>{
          if (item.annextypelist !== undefined) {
            item.annextypelist.forEach(item2=>{
              item2.progress = 0
            })
          }
        })
        if (res.records[0].annextypelist !== null && res.records[0].annextypelist!==undefined && res.records[0].annextypelist.length>0){
          res.records[0].annextypelist.forEach(item=>{
            item.progress = 0
            item.files.forEach(item3=>{
                  length ++
                })
          })
        }

        console.log(length,'tllll');
        let save = false
        for (let key = 0;key<result.length;key++){
          if (result[key].score !== undefined || result[key].score == ''){
            save = true
            break
          }
        }
        this.setState({
          data:result,
          title:res.records[0].title,
          annextypelist:res.records[0].annextypelist?res.records[0].annextypelist:[],
          save:save,
          result:res.records[0],
          length:length
        })
      } else {
        message.error(res.statemessage)
      }
    })
  }

  onSubmit(){
    Modal.confirm({
      content: '确认保存数据',
      okText: '确认',
      cancelText: '取消',
      onCancel:()=>{
      },
      onOk:()=>{
        this.onSubmitHandler()
      }
    })
  }

  //下一步
  nextHandler(){
    var data = JSON.parse(localStorage.getItem('menu'))
    const routers = []
    data.forEach(item=>{
      if (item.name === '博物馆数据') {
        if (item.children) {
          item.children.forEach(item1=>{
            if (item1.children){
              item1.children.forEach(item2=>{
                if (item2.children){
                  item2.children.forEach(item3=>{
                    routers.push(
                        { //基本信息
                          path: item3.rule,
                          attr: item3.attr,
                          id:item3.id
                        },
                    )
                  })
                }
              })
            }
          })
        }
      }
    })
    const showids = localStorage.getItem('showids')
    let resultIndex = -1
    let last = false
    for (let i =0;i<routers.length;i++){
      if(routers[i].attr === showids){
        resultIndex = i
        break
      }
    }
    if (resultIndex === routers.length - 1) {
      last = true
    }
      const result = JSON.parse(JSON.stringify(this.state.data))
      const params = []
      let flag = true
      result.forEach(item=> {
        if (item.score === '') {
          flag = false
        }
        if (item.dataid) {
          params.push({
            dataid:item.dataid,
            score:item.score,
            value:item.value,
          })
        }
      })
      this.setState({
        routers:routers
      })
    if (this.state.save){
        if (!flag) {
          Modal.confirm({
            content: '存在未填报项,确认保存数据到下一个填报页面?',
            okText: '确认',
            cancelText: '取消',
            onOk:()=>{
              this.confirmData(params,last,resultIndex)
            }
          })
        } else {
          this.confirmData(params,last,resultIndex)
        }
      } else {
        if (last){
          localStorage.setItem('chooseid','2210')
          this.props.history.push({
            pathname: '/home',
          });
        } else {
          setStorage('showids',routers[resultIndex+1].attr)
          localStorage.setItem('chooseid',routers[resultIndex+1].id)
          this.props.history.push({
            pathname: routers[resultIndex+1].path,
          });
        }
      }
  }
  confirmData(data,last,resultIndex){
    savedata(data).then(res=>{
      if(res.statecode === 0) {
        if (last){
          localStorage.setItem('chooseid','2210')
          this.props.history.push({
            pathname: '/home',
          });
        } else {
          setStorage('showids',this.state.routers[resultIndex+1].attr)
          localStorage.setItem('chooseid',this.state.routers[resultIndex+1].id)
          this.props.history.push({
            pathname: this.state.routers[resultIndex+1].path,
          });
        }
        this.props.refreshMenu(true)
      } else {
        message.error(res.statemessage)
      }
    })
  }

  radioChange(data,value){
    const result = JSON.parse(JSON.stringify(this.state.data))
    result.forEach(item=> {
      if (item.code === data.code) {
        item.value = value
        item.optionlist.forEach(item1=>{
          if (item1.value === value) {
            item.score = item1.score
          }
        })
      }
    })
    this.setState({
      data:result,
    })
  }

  inputChange(data,value){
    const result = JSON.parse(JSON.stringify(this.state.data))
    result.forEach(item=> {
      if (item.code === data.code) {
        if (0<Number(value) && Number(value)>Number(data.maxlimit)){
            message.error('您输入的分值不在范围内,请重新输入');
            item.score = ''
          } else {
            item.score = value
          }
      }
    })
    this.setState({
      data:result,
    })
  }

  saveInfo(data){
    if (data.score !=='' && Number(data.score) !== 0){
      if (!((/^\d+(?=\.{0,1}\d+$|$)/).test(data.score))) {
        message.error('分值为正数')
        return
      }
      if (data.inputpattern === 'decimal' && !(/^\d+(\.\d{1,2})?$/.test(data.score))){
        message.error('分值最多保留两位小数')
        return
      }

      if (data.inputpattern === 'integer' && !(/(^[1-9]\d*$)/.test(data.score))){
        message.error('分值为正整数')
        return
      }
    }

    const result = JSON.parse(JSON.stringify(this.state.data))
    const params = []
    result.forEach(item=> {
      if (item.code === data.code) {
        params.push({
          dataid:item.dataid,
          score:item.score,
          value:item.value,
        })
      }
    })

    savedata(params).then(res=>{
      if(res.statecode === 0) {
        message.success('保存成功');
        this.setState({
          data:result
        })
        this.props.refreshMenu(true)
      } else {
        message.error(res.statemessage);
      }
    })
  }

  lookscore(data){
    // data.forEach((item,index)=>{
    //   if (index!==0) {
    //     item[0] = index
    //   }
    // })
    if(data && data[0].rowlist &&data[0].rowlist.length > 0){
      this.setState({
        detailstatus:true,
        detaildata:data[0].rowlist,
      })
    } else {
      message.error('暂无评分信息');
    }

  }
  componentDidUpdate(){
  }

  componentDidMount(){
    const type = getStorage('userList').clerklevel
    this.setState({
      type:type
    })
    if (type == 8 || type == 9) {
      const result = JSON.parse(localStorage.getItem('userList'))
      const showids = localStorage.getItem('showids')
      this.setState({
        year:result.annual,
        indid:showids,
        meseum:false
      },()=>{
        this.onSelect()
      })
    } else {
      const result = JSON.parse(localStorage.getItem('userList'))
      const museumid = store.getState().libraryid
      const showids = localStorage.getItem('showids')
      this.setState({
        year:result.annual,
        museumid:museumid,
        indid:showids,
        meseum:true
      },()=>{
        this.onSelect()
      })
    }
    store.subscribe(() => {
      const state = store.getState()
      if (state.libraryname){
        const result = JSON.parse(localStorage.getItem('userList'))
        const museumid = store.getState().libraryid
        const showids = localStorage.getItem('showids')
        this.setState({
          year:result.annual,
          museumid:museumid,
          indid:showids,
          meseum:true
        },()=>{
          this.onSelect()
        })
      }
    })

  }

  componentWillUnmount() {
    if (this.state.save) {
      const result = JSON.parse(JSON.stringify(this.state.data))
      const params = []
      result.forEach(item=> {
        if (item.dataid) {
          params.push({
            dataid:item.dataid,
            score:item.score,
            value:item.value,
          })
        }
      })
      savedata(params).then(res=>{
        if(res.statecode === 0) {
          this.props.refreshMenu(true)
        } else {
          message.error(res.statemessage)
        }
      })
    }
    var el = document.getElementsByClassName(`store-manage-list-new`)[0];
    el.scrollIntoView(true);
  }


  render(){
    return (
      <div className='store-manage-list-new'>
        <List
            header={
              <div className='c-page-new-item-title' style={this.state.annextypelist.length>0?{height:((150*this.state.length+(this.state.annextypelist.length+1)*80))+'px'}:{height:'40px'}}>
                <span className='title-before-icon'></span>
                博物馆数据/{this.state.title}
                <div>
                  {(this.state.result.optionenable  == 'true' ||  (this.state.result.optionenable  === 'false' && this.state.annextypelist.length>0 ) )&& this.state.annextypelist.map((item1) => {
                    return <Card size="small" title={item1.name} extra={
                        <div>
                          {this.state.result.optionenable === 'true' &&
                              <div>
                                <Upload
                                    {...this.state.uploads}
                                    beforeUpload={(file, fileList) => this.beforeUpload1(file, item1)}
                                    onRemove={(file) => this.removeFile1(file, this.state.annextypelist)}
                                >
                                  {item1.files && item1.files.length >= 20 ? null : <div><Button type='primary'><img src={upload} alt=""
                                                                                                      style={{width: '20px'}}/>上传文件</Button>
                                  </div>}
                                </Upload>
                                {item1.progress>0?<Progress percent={item1.progress}/>:''}
                              </div>
                          }
                        </div>
                    } style={{ width: '100%',marginTop:"20px"}}>
                      {item1.files.map(item2=>{
                        return <Descriptions column={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1 }} bordered style={{marginBottom:'20px'}}>
                          <Descriptions.Item label="文件名称">{item2.filename}</Descriptions.Item>
                          <Descriptions.Item label="操作">
                            <Button type="link" onClick={()=>{this.handlePreview(item2)}}>预览</Button>
                            <Button type="link" onClick={()=>{this.downloads(item2)}} style={{marginLeft:'-20px'}}>下载</Button>
                            {
                              this.state.result.optionenable === 'true' &&
                                  <Button type="link" onClick={() => {
                                    this.removeFile1(item2, item1)
                                  }} style={{color: 'red', marginLeft: '-20px'}}>
                                    删除
                                  </Button>
                            }
                          </Descriptions.Item>
                        </Descriptions>
                      })}
                    </Card>
                  })}
                </div>
              </div>
        }
            footer={<div className='c-page-footer-button'>
              <CButton size='larger' onClick={()=>{this.nextHandler()}}>下一步</CButton>
                </div>
        }
            dataSource={this.state.data}
            renderItem={(item) => (
                <List.Item>
                  <div className='form-block'>
                    <div className="form-title">
                      <div className='form-title-left'>{item.name}
                        {item.tips !=='' && item.type !=='img' ? <Tooltip placement="right" title={decodeURIComponent(item.tips)}>
                          <img src={wenhao} alt="" style={{width:'17px',verticalAlign:'middle',marginLeft:'10px',cursor:'pointer'}}/>
                        </Tooltip>: ''}
                      </div>
                    </div>
                    <div className="form-form form-form-score" style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                     <div>
                       {item.scoretags && item.scoretags.map(item4=>{
                         return <Tag bordered={true} color="volcano">
                           {item4}
                         </Tag>
                       })}
                       { item.scoredetaillist && item.scoredetaillist.length > 0 ?
                           <Button size="small" type="primary" onClick={()=>{this.lookscore(item.scoredetaillist)}} style={{marginTop:0,fontSize:'12px'}}>
                             查看
                           </Button>:''}
                     </div>
                      {item.inputpattern &&  <div className='form-title-right'>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                          <span style={{color:'red',fontSize:'16px',fontWeight:'bold'}}>评分：</span><CInput value={item.score}
                                                    style={{
                                                      width: '60px',
                                                      margin: '5px 5px 5px 0',
                                                      borderColor:'red',
                                                      color: 'red'
                                                    }}
                                                    onChange={(value) => {
                                                      this.inputChange(item, value)
                                                    }} onBlur={() => {
                          this.saveInfo(item)
                        }}/><span>分</span>
                        </div>
                        <span className='scorerange'>分值范围:0-{item.maxlimit}</span>
                      </div>}
                    </div>
                    <div className="form-form">
                      {item.optionenable === 'true' ? item.optionlist &&
                          <div style={{display: 'flex', flexDirection: 'column'}}>
                            <CRadio value={item.value}
                                    options={item.optionlist}
                                    onChange={(value) => {
                                      this.radioChange(item, value)
                                    }}
                            />
                          </div> : <div style={{display:'flex',flexDirection:'column'}}>
                        {item.optionlist &&
                          item.optionlist.map(item3=>{
                            return <div className={item3.value === item.value?'item itemchoose':'item'}>{item3.name}</div>
                          })
                        }
                      </div>
                      }
                      <div>
                        {item.annextypelist && item.annextypelist.map((item1) => {
                          return <Card size="small" title={item1.name} extra={
                              item.optionenable === 'true' && <div>
                              <Upload
                                  {...this.state.uploads}
                                  beforeUpload={(file, fileList) => this.beforeUpload(file,item1,item)}
                                  onRemove={(file) => this.removeFile(file)}
                              >
                                {item1.files.length >=20 ? null :<div><Button type='primary'><img src={upload} alt="" style={{width:'20px'}}/>上传文件</Button></div> }
                              </Upload>
                              {item1.progress>0?<Progress percent={item1.progress}/>:''}
                            </div>
                          } style={{ width: '100%',marginTop:"20px" }}>
                            {item1.files.map(item2=>{
                              return <Descriptions column={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1 }} bordered style={{marginBottom:'20px'}}>
                                <Descriptions.Item label="文件名称">{item2.filename}</Descriptions.Item>
                                <Descriptions.Item label="操作">
                                  <Button type="link" onClick={()=>{this.handlePreview(item2)}}>预览</Button>
                                  <Button type="link" onClick={()=>{this.downloads(item2)}} style={{marginLeft:'-20px'}}>下载</Button>
                                  {item.optionenable === 'true' && <Button type="link" onClick={()=>{this.removeFile(item2,item)}} style={{color:'red',marginLeft:'-20px'}}>
                                    删除
                                  </Button>}
                                </Descriptions.Item>
                              </Descriptions>
                            })}
                          </Card>
                        })}
                      </div>
                    </div>
                  </div>
                </List.Item>
            )}
        />
        <Modal visible={this.state.previewVisible} footer={null} onCancel={this.modalCancel}>
          <div style={{width:'100%',height:'400px',display:'flex',justifyContent:'center',alignItems:'center'}}>
            <img alt="example" style={{ maxWidth: '400px' }} src={this.state.previewImage} />
          </div>
        </Modal>
        <Modal title="评分详情"
               visible={this.state.detailstatus}
               onCancel={this.handleCancelstatus}
               footer={[
                 <Button key="submit" type="primary" onClick={this.handleCancelstatus}>
                   取消
                 </Button>
               ]}
        >
          <div>
            {
              this.state.detaildata.map((item,index)=>{
                if (index === 0) {
                  return (<div style={{display:'flex',borderBottom:'1px solid #bebebe'}}>
                    {
                      item.map(item2=>{
                        return (
                            <div style={{flex:1,textAlign:'center'}}>{item2}</div>
                        )
                      })
                    }
                  </div>)
                } else {
                  return (<div style={{display:'flex',borderBottom:'1px solid #bebebe'}}>
                    {
                      item.map((item3)=>{
                        return (<div style={{flex:1,textAlign:'center',marginTop:'10px'}}>{item3}</div>)
                      })
                    }
                  </div>)
                }
              })
            }
          </div>
        </Modal>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    year: state.year,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Infomations);

